import { render, staticRenderFns } from "./report-gaoxueya.vue?vue&type=template&id=46a8b106&scoped=true&"
import script from "./report-gaoxueya.vue?vue&type=script&lang=ts&"
export * from "./report-gaoxueya.vue?vue&type=script&lang=ts&"
import style0 from "./report-gaoxueya.vue?vue&type=style&index=0&id=46a8b106&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a8b106",
  null
  
)

export default component.exports